import { takeLatest, call, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import request from '../../Utils/Request';
import {
  addOrUpdateDeviceStore,
  removeDevice,
  storeDevices,
  storeLicenses,
} from './Administration.reducer';
import { enableLoader, showMessageToast } from '../Login/Login.reducer';
import { makeUndefined } from '../../Utils/validationUtil';

export const fetchLicenses = createAction('FETCH_LICENSES');
export const fetchDevices = createAction('FETCH_DEVICES');
export const addOrUpdateDevice = createAction('ADD_OR_UPDATE_DEVICE');
export const deleteDevice = createAction('DELETE_DEVICE');

const licenses = {
  list: [
    {
      licenseName: 'visionAI456',
      licenseIsActive: true,
      licenseActivatedDate: 1599544955098,
      licenseExpiryDate: 1599544955098,
      licenseId: 1,
    },
    {
      licenseName: 'visionAI123',
      licenseIsActive: true,
      licenseActivatedDate: 1599544955098,
      licenseExpiryDate: 1599544955098,
      licenseId: 2,
    },
    {
      licenseName: 'visionAI789',
      licenseIsActive: false,
      licenseActivatedDate: 1599544955098,
      licenseExpiryDate: 1599544955098,
      licenseId: 3,
    },
  ],
  totalRecords: 3,
};

function* getLicenses(action) {
  try {
    const response = yield call(request, '/rest/administration/fetchLicenses', {
      action,
    });
    if (response.status === 200) {
      yield put(storeLicenses(licenses));
      if (action.payload.callback) {
        action.payload.callback(licenses.list[0]);
      }
    }
  } catch (error) {
    yield put(storeLicenses(licenses));
    if (action.payload.callback) {
      action.payload.callback(licenses.list[0]);
    }
  }
}

function* getDevices(action) {
  const { params, callback } = action.payload;
  const conditionCheck =
    params.sortBy === '' &&
    params.sortDirection === '' &&
    params.searchValue === '';
  try {
    if (conditionCheck) yield put(enableLoader(true));
    const payload = makeUndefined(params);
    const response = yield call(request, `/rest/input-clients`, {
      method: 'POST',
      data: {
        ...payload,
        offset: params.searchValue ? 0 : payload.offset,
      },
      action,
    });
    if (
      response.status === 200 &&
      response.entity &&
      response.entity.inputClients
    ) {
      yield put(storeDevices(response.entity));
      callback(response.entity.inputClients[0]);
    } else {
      callback({});
    }
    if (conditionCheck) yield put(enableLoader(false));
  } catch (error) {
    if (conditionCheck) yield put(enableLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message
          ? error.message
          : 'Fetching devices unsuccessful',
        type: 'error',
      })
    );
  }
}

function* updateOrAddDevice(action) {
  const { data, actionType, callback } = action.payload;
  try {
    yield put(enableLoader(true));
    const response = yield call(request, `/rest/input-client`, {
      method: 'PUT',
      data,
      action,
    });
    if (response.status === 200 && response.entity) {
      yield put(addOrUpdateDeviceStore({ data: response.entity, actionType }));
      callback(response.entity);
      yield put(
        showMessageToast({
          show: true,
          message: `${actionType ? 'Updated' : 'Added'} device successfully`,
          type: 'success',
        })
      );
    } else {
      callback({});
    }
    yield put(enableLoader(false));
  } catch (error) {
    callback({});
    yield put(enableLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message
          ? error.message
          : `${actionType ? 'Updating' : 'Adding'} device unsuccessful`,
        type: 'error',
      })
    );
  }
}

function* deviceDelete(action) {
  const { clientUuid, callback } = action.payload;
  try {
    yield put(enableLoader(true));
    const response = yield call(request, `/rest/input-client`, {
      method: 'DELETE',
      data: [clientUuid],
      action,
    });
    if (response.status === 200) {
      yield put(removeDevice(clientUuid));
      callback();
      yield put(
        showMessageToast({
          show: true,
          message: 'Deleted device successfully',
          type: 'success',
        })
      );
    }
    yield put(enableLoader(false));
  } catch (error) {
    callback();
    yield put(enableLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Deleting device unsuccessful',
        type: 'error',
      })
    );
  }
}

export default function* administrationSaga() {
  const watcher = [];
  watcher.push(yield takeLatest(fetchLicenses.toString(), getLicenses));
  watcher.push(yield takeLatest(fetchDevices.toString(), getDevices));
  watcher.push(
    yield takeLatest(addOrUpdateDevice.toString(), updateOrAddDevice)
  );
  watcher.push(yield takeLatest(deleteDevice.toString(), deviceDelete));
}
